module.exports = __webpack_public_path__ + "static/media/002.b4238d6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/002.png
// module id = 1577
// module chunks = 0